import { useSelector, shallowEqual } from 'react-redux';
import { getConversationById } from 'Selectors/webChat/consults';

export const useConversationActiveId = () => useSelector(state => state.webChat.conversationActive, shallowEqual);

export const useConversation = groupId => useSelector(
  state => getConversationById(state, groupId),
  shallowEqual,
);

export default useConversation;
